export default __webpack_public_path__ + "static/media/redLow.101be927.svg";